<div class="subscribe-dialog">
  <form [formGroup]="form">
    <div *ngIf="data.success === undefined" mat-dialog-content>
      <p class="title">
        Before you join the excitement of the upcoming tournament, please share
        your name and email with us.
      </p>
      <mat-form-field>
        <mat-label for="subscribeEmail">Enter your name</mat-label>
        <input
          matInput
          id="subscribeEmail"
          type="text"
          formControlName="name"
          required
        />
        <mat-icon matTextSuffix>account_circle</mat-icon>
        <mat-error class="mat-caption"> Name is required </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Enter your email</mat-label>
        <input
          matInput
          placeholder="pat@example.com"
          formControlName="email"
          type="email"
          required
        />
        <mat-icon matTextSuffix>mail</mat-icon>
        @if (form.invalid) {
          <mat-error class="mat-caption">
            @if (form.get('email')?.hasError('required')) {
              Email is required
            } @else if (form.get('email')?.hasError('email')) {
              Enter a valid email
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div *ngIf="data.success === undefined" mat-dialog-actions>
      <button
        mat-flat-button
        color="primary"
        [mat-dialog-close]="form.value"
        cdkFocusInitial
        data-ga-value="subscribe-ok-button"
      >
        Proceed
      </button>
      <button
        mat-stroked-button
        (click)="onNoClick()"
        data-ga-value="subscribe-cancel-button"
      >
        Not now
      </button>
    </div>
    <div *ngIf="data.success !== undefined">
      <p [ngClass]="{ success: data.success, error: !data.success }">
        {{ data.message }}
      </p>
    </div>
  </form>
</div>
